import { c as _c } from "react/compiler-runtime";
import { useField } from 'formik';
import { useContext, useEffect, useRef, useState } from 'react';
import useSWR from 'swr';
import APIMethodKeys from '../../../../../client/APIMethodKeys';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import Button from '../../../base/Button';
import Divider from '../../../base/Divider';
import Loading from '../../../base/Loading';
import Text from '../../../base/Text';
import { StyledOption } from '../../../Form/Fields/MultiSelectInput';
import { Div } from '../../../helpers/StyledUtils';
import Search from '../../../Search';
import { filterOutpostTenantBySearchTerm, getOutpostTenantLabel } from '../../../../scenes/OutpostScene/utils/tenantDisplay';
const formatOptions = (data: {
  models: Array<{
    id: string;
    metadata?: Record<string, unknown>;
  }>;
} | undefined) => data?.models.map(tenant => ({
  label: getOutpostTenantLabel(tenant.id, tenant),
  value: tenant.id
})) ?? [];
const formatFilters = (selected_ids?: string[]) => ({
  limit: 100,
  id: selected_ids?.length ? selected_ids : undefined
});
const OutpostTenantsFilter: React.FC<{
  name: string;
  title?: string;
  placeholder?: string;
  in_dropdown?: boolean;
  onBack?: () => void;
}> = t0 => {
  const $ = _c(61);
  const {
    name,
    placeholder,
    in_dropdown,
    onBack,
    title
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  let t1;
  if ($[0] !== name) {
    t1 = {
      name
    };
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [, t2, t3] = useField(t1);
  const {
    value
  } = t2;
  const {
    setValue,
    setTouched
  } = t3;
  const [search_term, setSearchTerm] = useState("");
  let t4;
  if ($[2] !== value) {
    t4 = value || [];
    $[2] = value;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const [applied_values, setAppliedValues] = useState(t4);
  const is_initial_mount = useRef(true);
  let t5;
  let t6;
  if ($[4] !== value) {
    t5 = () => {
      if (is_initial_mount.current) {
        setAppliedValues(value || []);
        is_initial_mount.current = false;
      }
    };
    t6 = [value];
    $[4] = value;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  let filters;
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    filters = formatFilters();
    t7 = useSWR;
    t8 = APIMethodKeys.outpost.tenants.list(filters);
    $[7] = filters;
    $[8] = t7;
    $[9] = t8;
  } else {
    filters = $[7];
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[10] !== HookdeckAPI.outpost.tenants) {
    t9 = () => HookdeckAPI.outpost.tenants.list(filters);
    $[10] = HookdeckAPI.outpost.tenants;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const {
    data,
    isValidating
  } = t7(t8, t9);
  let selected_filters;
  let t10;
  let t11;
  if ($[12] !== applied_values || $[13] !== search_term) {
    const ids = new Set(applied_values || []);
    if (search_term) {
      ids.add(search_term);
    }
    const selected_ids = ids.size > 0 ? Array.from(ids) : undefined;
    selected_filters = formatFilters(selected_ids);
    t10 = useSWR;
    t11 = selected_ids ? APIMethodKeys.outpost.tenants.list(selected_filters) : null;
    $[12] = applied_values;
    $[13] = search_term;
    $[14] = selected_filters;
    $[15] = t10;
    $[16] = t11;
  } else {
    selected_filters = $[14];
    t10 = $[15];
    t11 = $[16];
  }
  let t12;
  if ($[17] !== HookdeckAPI.outpost.tenants || $[18] !== selected_filters) {
    t12 = () => HookdeckAPI.outpost.tenants.list(selected_filters);
    $[17] = HookdeckAPI.outpost.tenants;
    $[18] = selected_filters;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const {
    data: selected_data
  } = t10(t11, t12);
  let T0;
  let T1;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  if ($[20] !== data || $[21] !== in_dropdown || $[22] !== isValidating || $[23] !== onBack || $[24] !== placeholder || $[25] !== search_term || $[26] !== selected_data || $[27] !== setTouched || $[28] !== setValue || $[29] !== title || $[30] !== value) {
    const selected_options = formatOptions(selected_data);
    const main_options = formatOptions(data).filter(option => {
      const tenant = data?.models.find(t20 => {
        const {
          id
        } = t20;
        return id === option.value;
      });
      return tenant ? filterOutpostTenantBySearchTerm(tenant, search_term) : false;
    });
    const selected_ids_0 = new Set(selected_options.map(_temp));
    const unique_main_options = main_options.filter(o_0 => !selected_ids_0.has(o_0.value));
    const filtered_options = [...selected_options, ...unique_main_options];
    T1 = Div;
    if ($[40] !== in_dropdown || $[41] !== onBack || $[42] !== placeholder || $[43] !== search_term || $[44] !== title) {
      t18 = in_dropdown ? <Div p={3} flex={{
        gap: 3,
        direction: "column"
      }}><Div flex={{
          align: "center",
          gap: 3
        }}><Button outline={true} small={true} icon="arrow_back" onClick={onBack} /><Text semi={true}>{title || "Filter by tenant"}</Text></Div><Search placeholder={placeholder || "Find a tenant ID or name"} small={true} onChange={setSearchTerm} value={search_term} /></Div> : <Search placeholder={placeholder || "Find a tenant ID or name"} small={true} borderless={true} onChange={setSearchTerm} value={search_term} focus={true} />;
      $[40] = in_dropdown;
      $[41] = onBack;
      $[42] = placeholder;
      $[43] = search_term;
      $[44] = title;
      $[45] = t18;
    } else {
      t18 = $[45];
    }
    if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = <Divider />;
      $[46] = t19;
    } else {
      t19 = $[46];
    }
    T0 = Div;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = {
        direction: "column"
      };
      $[47] = t13;
    } else {
      t13 = $[47];
    }
    t14 = 0;
    t15 = 1;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = {
        maxHeight: "300px",
        overflowY: "auto"
      };
      $[48] = t16;
    } else {
      t16 = $[48];
    }
    t17 = filtered_options.length > 0 ? filtered_options.map(o_1 => <StyledOption key={o_1.value} p={{
      x: 2,
      y: 1.5
    }} label={o_1.label} size="m" name={o_1.label} checked={value?.includes(o_1.value)} onChange={e => {
      setValue(e.currentTarget.checked ? [...(value || []), o_1.value] : (value || []).filter(v => v !== o_1.value));
      setTouched(true);
    }} />) : isValidating ? <Div p={{
      x: 3,
      y: 3
    }} flex={{
      justify: "center"
    }}><Loading /></Div> : <Div p={{
      x: 3,
      y: 3
    }}><Text muted={true}>No tenants</Text></Div>;
    $[20] = data;
    $[21] = in_dropdown;
    $[22] = isValidating;
    $[23] = onBack;
    $[24] = placeholder;
    $[25] = search_term;
    $[26] = selected_data;
    $[27] = setTouched;
    $[28] = setValue;
    $[29] = title;
    $[30] = value;
    $[31] = T0;
    $[32] = T1;
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
    $[39] = t19;
  } else {
    T0 = $[31];
    T1 = $[32];
    t13 = $[33];
    t14 = $[34];
    t15 = $[35];
    t16 = $[36];
    t17 = $[37];
    t18 = $[38];
    t19 = $[39];
  }
  let t20;
  if ($[49] !== T0 || $[50] !== t13 || $[51] !== t14 || $[52] !== t15 || $[53] !== t16 || $[54] !== t17) {
    t20 = <T0 flex={t13} m={t14} p={t15} style={t16}>{t17}</T0>;
    $[49] = T0;
    $[50] = t13;
    $[51] = t14;
    $[52] = t15;
    $[53] = t16;
    $[54] = t17;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] !== T1 || $[57] !== t18 || $[58] !== t19 || $[59] !== t20) {
    t21 = <T1>{t18}{t19}{t20}</T1>;
    $[56] = T1;
    $[57] = t18;
    $[58] = t19;
    $[59] = t20;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  return t21;
};
export default OutpostTenantsFilter;
function _temp(o) {
  return o.value;
}